import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { verifyTransaction } from "../../../actions/payment.action";
import VerifyPaymentLoader from "../../../components/loader/VerifyPaymentLoader";

export default function VerifyPayment() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const search = useLocation().search;
  const status = new URLSearchParams(search).get("status");
  const transactionRef = new URLSearchParams(search).get("tx_ref");
  const partnerRef = new URLSearchParams(search).get("transaction_id");

  const {
    payment: { partnerDetails, paymentLoading },
  } = useSelector(({ paymentReducer }) => ({
    payment: paymentReducer,
  }));

  useEffect(() => {
    const payload = {
      transactionRef,
      partnerRef,
    };

    const navigateLink = () => history.push("/document-processing");
    if (status === "cancelled") {
      history.push("/dashboard/user/document-processing/cart-orders");
    } else {
      dispatch(verifyTransaction(payload, navigateLink));
    }
  }, []);
  return (
    <div>
      <VerifyPaymentLoader />
    </div>
  );
}
